import React from 'react'
import { connect } from 'react-redux'
import { Field, Form, reduxForm, submit, change } from 'redux-form'

import StyledSVG from '../shared/StyledSVG'
import { makeStyles, Input } from '@material-ui/core'
import AsyncSelect from '../shared/AsyncSelect'
import searchIcon from '../../assets/icons/search-icon.svg'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: 40,
    flexWrap: 'wrap',
    [theme.breakpoints.down('1300')]: {
      gap: 24
    },
    [theme.breakpoints.down('750')]: {
      justifiContent: 'center',
      flexDirection: 'column'
    }
  },
  search_component: {
    backgroundColor: '#FFFFFF',
    width: 255,
    height: 48,
    borderRadius: 8,
    border: '1px #ADB8CC solid',
    padding: 12,
    [theme.breakpoints.down('1300')]: {
      width: 230
    },
    [theme.breakpoints.down('750')]: {
      width: '100%'
    },
    [theme.breakpoints.down('340')]: {
      '& input': {
        fontSize: '0.8rem'
      }
    }
  },
  search_field: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    '& div': {
      '& .select__control, .MuiInputBase-root': {
        width: 255,
        [theme.breakpoints.down('1300')]: {
          width: 230
        },
        [theme.breakpoints.down('750')]: {
          width: '100%'
        }
      }
    },
    [theme.breakpoints.down('750')]: {
      width: '100%'
    }
  }
}))
const ReportStudentFilterForm = ({
  filterValues,
  handleSubmit,
  onSubmit,
  touch,
  setFilterValues,
  setChildrenFetching,
  setSelectedChild,
  schoolId
}) => {
  const classes = useStyles()
  const selectGradeRef = React.useRef(null)
  const selectClassroomRef = React.useRef(null)

  const handleChange = (event, input) => {
    const inputName = input?.name || event?.target?.name
    const eventValue = event?.value || event?.target?.value
    touch(inputName)
    setFilterValues(prev => ({
      ...prev,
      [inputName]: String(eventValue).length > 0 ? eventValue : undefined
    }))
    setChildrenFetching(true)
    setSelectedChild(null)
  }

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <div className={classes.root}>
        <div className={classes.search_field}>
          <label htmlFor='grade_id'>Série</label>
          <Field
            component={AsyncSelect}
            selectRef={selectGradeRef}
            defaultOptions={false}
            id='grade_id'
            name='grade_id'
            value={filterValues?.grade_id}
            placeholder='Digite ou selecione'
            handleAsyncChange={handleChange}
            searchParam='q[name_cont]'
            request={{
              path: 'grade',
              params: {
                'q[classrooms_school_id_in]': schoolId
              }
            }}
            touch={touch}
          />
        </div>
        <div className={classes.search_field}>
          <label htmlFor='classroom_id'>Turma</label>
          <Field
            component={AsyncSelect}
            selectRef={selectClassroomRef}
            defaultOptions={false}
            value={filterValues?.classroom_id}
            id='classroom_id'
            name='classroom_id'
            placeholder='Digite ou selecione'
            handleAsyncChange={handleChange}
            searchParam='q[name_cont]'
            cacheUniqs={[filterValues.grade_id]}
            request={{
              path: 'classroom',
              params: {
                'q[grade_id_eq]': filterValues?.grade_id,
                'q[school_id_in]': schoolId,
                'q[year_lteq]': new Date().getFullYear() + 1,
                'q[year_gteq]': new Date().getFullYear()
              }
            }}
            touch={touch}
          />
        </div>
        <div className={classes.search_field}>
          <label htmlFor={'child_name'}>Busca</label>
          <Input
            disableUnderline
            value={
              filterValues?.child_name?.length > 0
                ? filterValues.child_name
                : ''
            }
            id='child_name'
            name='child_name'
            className={classes.search_component}
            placeholder='Digite o nome do aluno'
            onChange={handleChange}
            startAdornment={
              <StyledSVG
                style={{ marginRight: 4 }}
                src={searchIcon}
                width={18}
                height={18}
              />
            }
          />
        </div>
      </div>
    </Form>
  )
}

const mapStateToProps = (state, props) => {
  return {
    formErrors: state?.form?.reportStudentFilterForm?.syncErrors
  }
}

const mapDispatchToProps = dispatch => ({
  change: (field, data) =>
    dispatch(change('ReportStudentFilterForm', field, data)),
  submit: () => dispatch(submit('ReportStudentFilterForm'))
})

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'ReportStudentFilterForm',
    touchOnChange: true,
    touchOnBlur: true,
    onSubmit: async (values, dispatch, props) => {}
  })(ReportStudentFilterForm)
)
